import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async pegaItem(itemID = {}){

        let item;

        try{

            //==================================================================//
            //============================ Pega Item ===========================//
            //==================================================================//

            item = await ERP.getOneById(Schema.JOB_ITENS, itemID);
            if(item.status != 200){
                throw item;
            }

            console.log(item);


        }catch(e){

            console.log(e);
            return item;

        }

        return item;

    },

    async pegaItens(itensIDs = []){

        let itens;

        try{

            //==================================================================//
            //=========================== Pega Itens ===========================//
            //==================================================================//

            itens = await ERP.getManyById(Schema.JOB_ITENS, itensIDs);
            if(itens.status != 200){
                throw itens;
            }

            console.log(itens);


        }catch(e){

            console.log(e);
            return itens;

        }

        return itens;

    },

    async criaItem(itemValores = {}){

        let item;

        try{

            //==================================================================//
            //=====================-====== Cria Item ==========-================//
            //==================================================================//

            itemValores = {
                status: "Em Desenvolvimento",
                ...itemValores,
            }

            item = await ERP.postOne(Schema.JOB_ITENS, itemValores);
            if(item.status != 200){
                throw item;
            }

            console.log(item);


        }catch(e){

            console.log(e);
            return item;

        }

        return item;

    },

    async alteraItem(itemValores = {}){

        let item;

        try{

            //==================================================================//
            //=========================== Altera Item ==========================//
            //==================================================================//

            item = await ERP.patchOne(Schema.JOB_ITENS, itemValores);
            if(item.status != 200){
                throw item;
            }

            console.log(item);


        }catch(e){

            console.log(e);
            return item;

        }

        return item;

    },

    async alterarItens(itensValores = []){

        let itens;

        try{

            //==================================================================//
            //========================== Altera Itens ==========================//
            //==================================================================//

            itens = await ERP.patchMany(Schema.JOB_ITENS, itensValores);
            if(itens.status != 200){
                throw itens;
            }

            console.log(itens);

        }catch(e){

            console.log(e);
            return itens;

        }

        return itens;

    },

    async removeItem(itemValores = {}){

        let item;

        try{

            //==================================================================//
            //=========================== Remove Item ==========================//
            //==================================================================//

            itemValores = {
                ...itemValores,
                status: "Cancelado",
            }

            item = await this.alteraItem(itemValores);
            if(item.status != 200){
                throw item;
            }

        }catch(e){

            console.log(e);
            return item;

        }

        return item;

    },

}